/* eslint-disable react/no-danger */
import React from 'react';

import { RecyclablePacksHeroBannerData } from './models';

import './RecyclablePacksHeroBanner.scss';

interface RecyclablePacksHeroBannerProps {
  data?: RecyclablePacksHeroBannerData;
}

const RecyclablePacksHeroBanner = ({ data }: RecyclablePacksHeroBannerProps) => {
  const {
    finishLogo,
    autoDishBrandLogo,
    heading,
    mainPackshot,
    disclaimer,
    bgImageDesktop,
    bgImageMobile,
  } = data || {};

  return (
    <section
      className="recyclable-packs-hero-banner"
      style={
        {
          '--bg-image-desktop': `url(${bgImageDesktop?.url ?? ''})`,
          '--bg-image-mobile': `url(${bgImageMobile?.url || bgImageDesktop?.url || ''})`,
        } as React.CSSProperties
      }
    >
      <div className="icons-section">
        {finishLogo && (
          <img className="icons-section__finish-logo" src={`${finishLogo.url}`} alt="Finish Logo" />
        )}
        {autoDishBrandLogo && (
          <img className="icons-section__brandN1" src={`${autoDishBrandLogo.url}`} alt="brand №1" />
        )}
      </div>

      {heading && <div className="heading-section" dangerouslySetInnerHTML={{ __html: heading }} />}

      {mainPackshot && (
        <div className="main-image-container">
          <img src={mainPackshot.url} alt="Finish ultimate plus in recyclable paper pack" />
        </div>
      )}

      {disclaimer && (
        <div className="disclaimer" dangerouslySetInnerHTML={{ __html: disclaimer }} />
      )}
    </section>
  );
};

RecyclablePacksHeroBanner.displayName = 'RecyclablePacksHeroBanner';
export default RecyclablePacksHeroBanner;
